// Static catalog of supported integrations, grouped by category. Rendered by
// the Integrations settings page. Only the integrations we have components for:
// HubSpot, Mixpanel, Amplitude, Slack.
import {
  HiOutlineChartBar,
  HiOutlineOfficeBuilding,
  HiOutlineChatAlt2,
} from "react-icons/hi";
import { SiHubspot, SiSlack, SiMixpanel, SiPosthog } from "react-icons/si";

// status: "connected" | "error" | "available"; logo: brand logo (react-icons).
export const INTEGRATION_CATEGORIES = [
  {
    key: "communication",
    label: "Communication",
    icon: HiOutlineChatAlt2,
    description: "Alerts and shared channels.",
    services: [
      {
        id: "slack",
        name: "Slack",
        status: "connected",
        logo: SiSlack,
      },
    ],
  },
  {
    key: "crm",
    label: "CRM",
    icon: HiOutlineOfficeBuilding,
    description: "Accounts, deals, owners.",
    services: [
      {
        id: "hubspot",
        name: "HubSpot",
        status: "connected",
        logo: SiHubspot,
      },
    ],
  },
  {
    key: "product_analytics",
    label: "Product Analytics",
    icon: HiOutlineChartBar,
    description: "Usage, active users, feature adoption.",
    services: [
      {
        id: "mixpanel",
        name: "Mixpanel",
        status: "connected",
        logo: SiMixpanel,
      },
      {
        id: "amplitude",
        name: "Amplitude",
        status: "available",
        // Amplitude has no Simple Icons logo in react-icons — fall back to a chart glyph.
        logo: HiOutlineChartBar,
      },
      {
        id: "posthog",
        name: "PostHog",
        status: "available",
        logo: SiPosthog,
      },
    ],
  },
];

// The single "active" service in a category (connected or errored), if any.
export const activeService = (category) =>
  category.services.find(
    (s) => s.status === "connected" || s.status === "error",
  ) || null;
